module.exports = __webpack_public_path__ + "static/media/Orc.7f4d7a4f.jpg";